import { render, staticRenderFns } from "./MessageAsComment.vue?vue&type=template&id=7cac1b86&scoped=true"
import script from "./MessageAsComment.vue?vue&type=script&lang=js"
export * from "./MessageAsComment.vue?vue&type=script&lang=js"
import style0 from "./MessageAsComment.vue?vue&type=style&index=0&id=7cac1b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cac1b86",
  null
  
)

export default component.exports